import * as React from "react";

import { RobotoButton } from "@/shared/foundation/primitives";

import { useTimelineContext } from "./TimelineContext";
import styles from "./TimelineTracks.module.css";

interface NoSessionsInSpanProps {
  /**
   * Move the window to the closest item before or after it, without selecting
   * it. The zoom level is kept unless the item is longer than the window.
   */
  onJumpToNearest: () => void;
}

/**
 * What the tracks show when the window holds no item although some exist:
 * a message and two ways out, jumping to the nearest item or fitting all.
 * The overlay itself lets pointer events through, so the empty span can
 * still be dragged to pan. Pointer presses on the actions stop here, so a
 * click on either is not also a tap on empty track space.
 */
export function NoSessionsInSpan({ onJumpToNearest }: NoSessionsInSpanProps) {
  const { fitAll } = useTimelineContext();
  const titleId = React.useId();
  const stop = (event: React.SyntheticEvent) => event.stopPropagation();
  return (
    <div className={styles.empty} role="status" aria-labelledby={titleId}>
      <p id={titleId} className={styles.emptyTitle}>
        No sessions in this span
      </p>
      <div
        className={styles.emptyActions}
        onPointerDown={stop}
        onPointerUp={stop}
      >
        <RobotoButton variant="ghost" size="sm" onClick={onJumpToNearest}>
          Jump to nearest
        </RobotoButton>
        <RobotoButton variant="ghost" size="sm" onClick={fitAll}>
          Fit all
        </RobotoButton>
      </div>
    </div>
  );
}
